/**
 * Orbit Trends — Minimal Scroll-Reveal & UI Engine
 *
 * Responsibilities (deliberately small):
 *   1. Pre-mark elements already in the viewport as visible.
 *   2. Add `orbit-js-ready` to <body> so the CSS animation system activates.
 *   3. IntersectionObserver-driven reveal for .orbit-reveal*, .orbit-stagger.
 *   4. Scroll-to-top button show/hide + click handler.
 *
 * Intentionally excluded (proved to cause visual bugs in earlier build):
 *   Three.js particles, 2D CSS particle fallback, cursor glow, card tilt,
 *   GSAP integrations, cart-bounce, button-ripple, heading SVG accents.
 */
(function () {
  'use strict';

  var REVEAL_SELECTORS = [
    '.orbit-reveal',
    '.orbit-reveal-left',
    '.orbit-reveal-right',
    '.orbit-reveal-scale',
    '.orbit-stagger',
  ].join(', ');

  /* ── 1. Pre-mark elements already in the viewport as .orbit-visible.
          This MUST happen before adding orbit-js-ready to body, so the
          CSS opacity:0 that orbit-js-ready enables never flashes these
          already-visible elements. ── */
  document.querySelectorAll(REVEAL_SELECTORS).forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight + 120 && rect.bottom > 0) {
      el.classList.add('orbit-visible');
    }
  });

  /* ── 2. Signal JS is ready so CSS can enable the animation system ── */
  document.body.classList.add('orbit-js-ready');

  /* ── 3. IntersectionObserver for below-the-fold elements ── */
  function revealAll(container) {
    (container || document).querySelectorAll(REVEAL_SELECTORS).forEach(function (el) {
      el.classList.add('orbit-visible');
    });
  }

  if (!('IntersectionObserver' in window)) {
    /* Older browsers: show everything immediately */
    revealAll();
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('orbit-visible');
            io.unobserve(entry.target);
          }
        });
      },
      {
        /* Trigger a little before element enters the viewport */
        threshold: 0.06,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    document.querySelectorAll(REVEAL_SELECTORS).forEach(function (el) {
      if (!el.classList.contains('orbit-visible')) {
        io.observe(el);
      }
    });

    /* Re-observe sections injected by theme-editor live preview */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        e.target.querySelectorAll(REVEAL_SELECTORS).forEach(function (el) {
          el.classList.add('orbit-visible');
        });
      });
    }
  }

  /* ── 4. Scroll-to-top button ── */
  var scrollBtn = document.querySelector('.orbit-scroll-top');
  if (scrollBtn) {
    window.addEventListener(
      'scroll',
      function () {
        scrollBtn.classList.toggle('orbit-scroll-top--visible', window.scrollY > 400);
      },
      { passive: true }
    );
    scrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();


